export default (str, excludes = []) => {
  return str.toLowerCase().split(/[\s-_]/).map(word => {
    if (excludes.includes(word) && str.indexOf(word) > 0) {
      return word;
    } else {
      return word.replace(word[0], word[0].toUpperCase());
    }
  }).join(' ');
};
